import { useGetStaffInfoQuery } from "apis/services/auth";
import { useSelector } from "react-redux";
import { RootState } from "reducers";

export default function useGetUserInfo({ skip }: { skip?: boolean } = {}) {
  const token = useSelector((state: RootState) => state.auth.token);

  const { data: userInfo, isFetching: isUserInfoLoading } =
    useGetStaffInfoQuery(undefined, { skip: !token || skip });

  return {
    isAdmin: userInfo?.user?.is_superuser,
    userInfo,
    isUserInfoLoading,
    role: userInfo?.group?.name,
  };
}
